<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Modal from 'dashboard/components/Modal.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import InboxesAPI from 'dashboard/api/inboxes';

const show = defineModel('show', { type: Boolean, default: false });

const getters = useStoreGetters();
const { t } = useI18n();

const availableInboxes = computed(() =>
  getters['inboxes/getInboxes'].value.filter(inbox =>
    ['Channel::Api', 'Channel::Whatsapp', 'Channel::Email'].includes(
      inbox.channel_type
    )
  )
);

const targetInboxes = computed(() => {
  const sourceInbox = availableInboxes.value.find(
    inbox => inbox.id === fromInboxId.value
  );
  if (sourceInbox?.channel_type === 'Channel::Email') {
    return availableInboxes.value.filter(
      inbox => inbox.channel_type === 'Channel::Email'
    );
  }
  return availableInboxes.value;
});

const fromInboxId = ref('');
const toInboxId = ref('');

const migrate = async () => {
  try {
    await InboxesAPI.migrate({
      from_inbox_id: fromInboxId.value,
      to_inbox_id: toInboxId.value,
    });
    useAlert(t('INBOX_MGMT.MIGRATE.API.SUCCESS_MESSAGE'));
    show.value = false;
  } catch (error) {
    useAlert(t('INBOX_MGMT.MIGRATE.API.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <Modal v-model:show="show" :on-close="() => (show = false)">
    <woot-modal-header :header-title="t('INBOX_MGMT.MIGRATE.TITLE')" />
    <div class="flex flex-col gap-4 p-8">
      <div>
        <label class="block mb-1">{{ t('INBOX_MGMT.MIGRATE.FROM') }}</label>
        <select v-model="fromInboxId" class="w-full p-2 border rounded">
          <option disabled value="">{{ t('INBOX_MGMT.MIGRATE.SELECT_INBOX') }}</option>
          <option v-for="inbox in availableInboxes" :key="inbox.id" :value="inbox.id">
            {{ inbox.name }}
          </option>
        </select>
      </div>
      <div>
        <label class="block mb-1">{{ t('INBOX_MGMT.MIGRATE.TO') }}</label>
        <select v-model="toInboxId" class="w-full p-2 border rounded">
          <option disabled value="">{{ t('INBOX_MGMT.MIGRATE.SELECT_INBOX') }}</option>
          <option v-for="inbox in targetInboxes" :key="inbox.id" :value="inbox.id">
            {{ inbox.name }}
          </option>
        </select>
      </div>
      <div class="flex justify-end gap-2">
        <Button faded slate @click="show = false" :label="t('INBOX_MGMT.MIGRATE.CANCEL')" />
        <Button ruby :disabled="!fromInboxId || !toInboxId" @click="migrate" :label="t('INBOX_MGMT.MIGRATE.SUBMIT')" />
      </div>
    </div>
  </Modal>
</template>
